// extracted by mini-css-extract-plugin
module.exports = {"PaginationBarContainer":"Pagination_PaginationBarContainer__1yGxc","PaginationBarItem":"Pagination_PaginationBarItem__2957_","CurrentPage":"Pagination_CurrentPage__1LOfU"};